export const DEMO_INVOICE_E_INVOICING_ADDRESS = '123456789-demo-e-invoice'
